export default {
  common: {
    loading: 'ローディング中...',
    networkError: 'ネットワーク異常、ネットワーク設定を確認するか、IT5000に連絡してください。',
    minutes: 'min',
    hour: 'h',
    readyToStart: '未開始',
    ing: '会議中',
    finishedAuto: '自動終了',
    finishedByPresenter: 'ホストがビデ才会議を終了',
    plsOpenInBrowser: 'ブラウザで開く',
    plsOpenInSafari: 'safariで開く',
    ok: 'ok',
    stillUse: 'はい',
    or: 'または'
  },
  meeting: {
    detail: '会議情報',
    chinaRecommend: 'Mideaグループ従業員に推奨',
    outsideRecommend: 'Midea社員(海外)・ゲストに推奨',
    openInMission: '美信で参加',
    openInMideaMeeting: 'MideaMeetingで参加',
    notStart: '会議はまだ開始していません',
    hasFinished: '会議が既に終了しました',
    hasCanceled: '開始がキャンセルされました',
    openMission: 'そのページが美信を開こうとしています',
    clickDownloadMission: '正常に参加できない場合、まずは「美信をダウンロード」ボタンを押してください',
    installedMission: '既に美信をインストールした場合、',
    clickHere: 'ここをクリックしてください',
    openMissionTips: 'ブラウザダイアログがポップアップした場合、「美信を開く」ボタンを押してください',
    donwloadMissionImed: 'Midea Connectをダウンロード',
    downloadMideaMeeting: 'MMダウンロード',
    openMideaMeeting: 'そのページがMidea　Meetingを開こうとしています',
    clickDownload: '正常に開けない場合、まずは「ダウンロード」ボタンを押してください',
    installedMideaMeeting: '既にMidea Meeting をインストールした場合、',
    browserDialogOpened: 'ブラウザダイアログがポップアップした場合',
    clickOpenMideaMeetingBtn: '「Midea Meeting を開く」ボタンを押してください',
    donwloadImed: 'ダウンロード',
    dontWantToDownload: 'ダウンロードしたくない？',
    joinMeetingInBrowser: 'ブラウザで参加',
    cancelMeetingInfo: '下記の会議情報が失効されました',
    otherToMeeting: 'その他の参加方法',
    browserMeetingTips: '対応するブラウザはChrome/Firefox/Safariのみです。ブラウザで参加する場合、会議品質が低下することがあります。',
    readingGuideline: '詳細な操作ガイドラインを確認してください',
    openInWXMeeting: 'VooV Meetingで参加',
    openInWXApplet: 'Mini Programで参加',
    openTXMeeting: 'VooV Meeting を開く」ボタンを押してください',
    clickDownloadTXMeeting: '正常に開けない場合、まずは「ダウンロード」ボタンを押してください',
    needTXMeeting: '他の方法で会議に参加する',
    installedTXMeeting: '既にVooV Meeting をインストールした場合 ',
    openTXMeetingTips: 'ブラウザダイアログがポップアップした場合，「VooV Meeting を開く」ボタンを押してください',
    donwloadTXMeetingImed: 'ダウンロード',
    downloadMX: '美信をダウンロード',
    downloadTXMeeting: 'VooV Meetingをダウンロード',
    back: '会議の詳細へ戻る',
    isNotChinesePhone: '中国本土の携帯電話番号をご利用の方は、以下をクリックしてください',
    downloadVooV: 'Tencent Meetingをダウンロード',
    scan: '長押して保存し、WeChatでスキャンする',
    joinInMeeting: 'カンファレンスに参加する',

  }
}
